import {
  array, number, object, oneOfType, string,
} from 'prop-types';
import React, { PureComponent } from 'react';

import { LAYOUT } from '../../common';
import { LAYOUT as REACTOR } from '../../reactor/common';
import { Image } from '../../reactor/components';

export default class ImageContent extends PureComponent {
  static propTypes = {
    uri: string.isRequired,
    style: oneOfType([array, number, object]),
  };

  static defaultProps = {
    style: [],
  };

  render() {
    const { uri, style } = this.props;
    // console.log(style)

    return (
      <Image
        ratio={REACTOR.VIEWPORT.PORTRAIT ? 1 : 2}
        resizeMode="cover"
        responsive
        source={{ uri }}
        style={[LAYOUT.STYLE.media, style]}
      />
    );
  }
}
